// Centimetre rulers in the margin above and left of the canvas, so the customer sees how big
// the print really is. 0 sits at the die line, not at the bleed edge; `o` is where the canvas
// starts on the stage. Ticks only, no numbers:
// short every 5 mm, medium every cm, long every 5 cm.

import { Group, Line } from 'react-konva';
import type { Geometry } from './geometry';

export const RULER_PX = 22;
const INK = '#333';

const tickLength = (t: number) => (t % 50 === 0 ? 14 : t % 10 === 0 ? 8 : 4);

export function Ruler({ g, s, o }: { g: Geometry; s: number; o: number }) {
  const mm = g.pxPerMm * s; // stage px per mm
  const R = RULER_PX;
  const x0 = o + g.bleedMm * mm, y0 = o + g.bleedMm * mm;
  const w = g.trimWidthMm, h = g.trimHeightMm;
  const ticks = (len: number) => Array.from({ length: Math.floor(len / 5) + 1 }, (_, i) => i * 5);
  return (
    <Group listening={false}>
      <Line points={[x0, R - 1, x0 + w * mm, R - 1]} stroke={INK} strokeWidth={1} />
      <Line points={[R - 1, y0, R - 1, y0 + h * mm]} stroke={INK} strokeWidth={1} />
      {ticks(w).map((t) => (
        <Line key={`x${t}`} points={[x0 + t * mm, R - 1, x0 + t * mm, R - 1 - tickLength(t)]} stroke={INK} strokeWidth={t % 50 ? 1 : 1.5} />
      ))}
      {ticks(h).map((t) => (
        <Line key={`y${t}`} points={[R - 1, y0 + t * mm, R - 1 - tickLength(t), y0 + t * mm]} stroke={INK} strokeWidth={t % 50 ? 1 : 1.5} />
      ))}
    </Group>
  );
}
